import api from './api';

const register = (username, email, password, company) => {
    return api.post("/auth/signup", {
        username,
        email,
        password,
        company,
    });
};

const login = (username, password, rememberMe) => {
    return api
        .post("/auth/signin", {
            username,
            password,
            rememberMe,
        })
        .then((response) => {
            if (response.data.accessToken) {
                const user = {
                    ...response.data,
                    rememberMe: rememberMe
                };
                localStorage.setItem("user", JSON.stringify(user));
            }
            return response.data;
        });
};

const logout = () => {
    localStorage.removeItem("user");
};

/**
 * Prihlásenie telefónnym číslom — pre majiteľov, ktorí sú zároveň zamestnanci
 * a heslo do admina nemajú. Server ich nájde cez väzbu v employee_employer_roles.
 */
const phoneLookup = (phone) => {
    return api.post("/auth/employer/phone-lookup", { phone });
};

const phoneRequestOtp = (phone, employeeId) => {
    return api.post("/auth/employer/request-otp", { phone, employeeId });
};

const phoneVerifyOtp = (employeeId, otp) => {
    return api
        .post("/auth/employer/verify-otp", { employeeId, otp })
        .then((response) => {
            if (response.data.accessToken) {
                // rememberMe zámerne true: kto sa prihlasuje číslom, nemá heslo,
                // ktorým by sa vrátil — vypadnutie po 24 h by ho vyhodilo von.
                localStorage.setItem(
                    "user",
                    JSON.stringify({ ...response.data, rememberMe: true })
                );
            }
            return response.data;
        });
};

const googleLogin = (token) => {
    return api
        .post("/auth/google/signin", {
            token,
        })
        .then((response) => {
            if (response.data.accessToken) {
                // Set rememberMe to true for Google users by default
                const user = {
                    ...response.data,
                    rememberMe: true
                };
                localStorage.setItem("user", JSON.stringify(user));
            }
            return response.data;
        });
};

const googleLoginWithToken = (accessToken) => {
    return api.post("/auth/google-signin-token", { accessToken: accessToken })
        .then(response => {
            if (response.data.accessToken) {
                localStorage.setItem("user", JSON.stringify(response.data));
            }
            return response.data;
        });
};

const resendVerification = (username) => {
    return api.post("/auth/resend-verification", {
        username,
    });
};

const getCurrentUser = () => {
    const userStr = localStorage.getItem("user");
    if (userStr) {
        const user = JSON.parse(userStr);
        // If user doesn't want to be remembered, check if token is expired
        if (!user.rememberMe) {
            // simple check, you might want a more robust solution with jwt-decode
            // For now, let's assume if it exists, it's valid for the session
        }
        return user;
    }
    return null;
};

const authService = {
    register,
    login,
    logout,
    googleLogin,
    resendVerification,
    getCurrentUser,
    googleLoginWithToken,
    phoneLookup,
    phoneRequestOtp,
    phoneVerifyOtp,
};

export default authService;




